import { errorMessageForAddYearField } from 'constants/constants';
import * as Yup from 'yup';

const addYearValidationSchema = Yup.object().shape({
    fromYear: Yup.string().typeError(errorMessageForAddYearField).required(errorMessageForAddYearField)
})

export default addYearValidationSchema